(function(){
  const $=(s,c)=>(c||document).querySelector(s);
  const $$=(s,c)=>[...(c||document).querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.Theme = window.Theme || {};
  document.documentElement.classList.remove('no-js');

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}
  }),{threshold:.12});
  function observeReveals(root){ $$('.rv', root).forEach(el=>io.observe(el)); }
  observeReveals(document);

  /* ---------- count up ---------- */
  const co = new IntersectionObserver(es=>es.forEach(e=>{
    if(!e.isIntersecting) return; co.unobserve(e.target);
    const el=e.target, end=+el.dataset.count, suf=el.dataset.suffix||'';
    if(reduce){el.textContent=end+suf;return}
    let t0;
    const step=t=>{t0??=t;const p=Math.min((t-t0)/1200,1);el.textContent=Math.round(end*(1-Math.pow(1-p,3)))+suf;if(p<1)requestAnimationFrame(step)};
    requestAnimationFrame(step);
  }),{threshold:.5});
  $$('[data-count]').forEach(el=>co.observe(el));

  /* ---------- parallax ---------- */
  let tick=false; const pxEls=$$('[data-parallax]');
  if(pxEls.length){
    addEventListener('scroll',()=>{
      if(tick) return; tick=true;
      requestAnimationFrame(()=>{
        if(!reduce) pxEls.forEach(px=>{
          const b=px.parentElement.getBoundingClientRect();
          px.style.transform=`translate3d(0,${(b.top/innerHeight)*-50}px,0)`;
        });
        tick=false;
      });
    },{passive:true});
  }

  /* ---------- lightbox ---------- */
  const lb=$('#lb');
  if(lb){
    const lbi=lb.querySelector('img'); let lastF;
    const openLb=(src,alt,trigger)=>{lastF=trigger;lbi.src=src;lbi.alt=alt||'';lb.classList.add('on');lb.querySelector('button').focus()};
    const closeLb=()=>{lb.classList.remove('on');lastF&&lastF.focus()};
    function bindLightbox(root){
      $$('[data-lightbox-item]', root).forEach(f=>{
        if(f.dataset.lbBound) return; f.dataset.lbBound='1';
        f.tabIndex=0; f.setAttribute('role','button');
        const open=()=>{const i=f.querySelector('img')||( f.tagName==='IMG'?f:null); if(i) openLb(i.src,i.alt,f)};
        f.addEventListener('click',open);
        f.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open()}});
      });
    }
    bindLightbox(document);
    window.Theme.bindLightbox = bindLightbox;
    lb.addEventListener('click',e=>{if(e.target!==lbi) closeLb()});
    addEventListener('keydown',e=>{if(e.key==='Escape'&&lb.classList.contains('on')) closeLb()});
  }

  /* ---------- toast ---------- */
  const toast=$('#toast');
  let toastTimer;
  function showToast(text){
    if(!toast) return;
    const t=$('#toastTxt',toast); if(t) t.textContent=text||'';
    toast.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(()=>toast.classList.remove('on'),3500);
  }
  window.Theme.showToast = showToast;

  /* ---------- cart count ---------- */
  function updateCartCount(count){
    $$('.cart-count').forEach(cc=>{cc.textContent=count;cc.classList.toggle('on',count>0)});
  }
  window.Theme.updateCartCount = updateCartCount;
  function refreshCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(cart=>updateCartCount(cart.item_count)).catch(()=>{});
  }
  window.Theme.refreshCartCount = refreshCartCount;
  refreshCartCount();

  /* ---------- add to cart (AJAX) ---------- */
  function addToCart(items, opts){
    opts = opts || {};
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items: items})
    }).then(r=>r.json().then(data=>({ok:r.ok,data}))).then(({ok,data})=>{
      if(!ok){ document.dispatchEvent(new CustomEvent('theme:cart:error',{detail:{data,opts}})); throw data; }
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('theme:cart:added', {detail:{data, opts}}));
      return data;
    });
  }
  window.Theme.addToCart = addToCart;

  document.addEventListener('theme:cart:added', e=>{
    const label = (e.detail && e.detail.opts && e.detail.opts.label) || (window.themeStrings && window.themeStrings.addedToCart) || 'Ajouté au panier';
    showToast(label);
    if(window.Theme.settings && window.Theme.settings.cartType === 'page'){
      window.location.href = '/cart';
    }
  });
  document.addEventListener('theme:cart:error', e=>{
    const msg = (e.detail && e.detail.data && e.detail.data.description) || 'Une erreur est survenue.';
    showToast(msg);
  });

  /* ---------- sticky bar tied to an anchor element ---------- */
  const anchors = $$('[data-sticky-anchor]');
  if(anchors.length){
    const onScroll = ()=>{
      anchors.forEach(anchor=>{
        const sticky = document.getElementById(anchor.dataset.stickyAnchor);
        if(!sticky) return;
        const r = anchor.getBoundingClientRect();
        sticky.classList.toggle('on', r.bottom < 0 && innerHeight + scrollY < document.body.scrollHeight - 300);
      });
    };
    addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- generic quantity steppers [data-qty] ---------- */
  function bindQty(root){
    $$('[data-qty]', root).forEach(wrap=>{
      if(wrap.dataset.qtyBound) return; wrap.dataset.qtyBound='1';
      const input = wrap.querySelector('[data-qty-value]');
      const minus = wrap.querySelector('[data-qty-minus]');
      const plus = wrap.querySelector('[data-qty-plus]');
      const max = +wrap.dataset.qtyMax || 999;
      const get=()=> +(input.value||input.textContent||1);
      const set=v=>{
        v=Math.max(1,Math.min(max,v));
        if('value' in input) input.value=v; else input.textContent=v;
        wrap.dispatchEvent(new CustomEvent('qty:change',{detail:{value:v},bubbles:true}));
      };
      minus && minus.addEventListener('click', ()=>set(get()-1));
      plus && plus.addEventListener('click', ()=>set(get()+1));
      input && input.addEventListener('change', ()=>set(get()));
    });
  }
  bindQty(document);
  window.Theme.bindQty = bindQty;

  /* ---------- accessible details/summary reveal for .rv within acc ---------- */
})();
